import React from "react";
import { Tooltip } from "reactstrap";

interface propsTypes {
  children?: React.ReactNode;
  target: string | HTMLElement | React.RefObject<HTMLElement>;
  placement?: any;
  isOpen?: boolean;
  className?: string;
  toggle?: () => void;
  trigger?: string;
  autohide?: boolean;
}

const ToolTip = (props: propsTypes) => {
  const { children, ...res } = props;
  return <Tooltip {...res}>{children}</Tooltip>;
};

export default ToolTip;
